// import components
import BulkApproveDuties from './components/BulkApproveDuties';
import DutyLineSummaryGrid from './components/DutyLineSummaryGrid';
import PeriodSelector from './components/PeriodSelector';
import RealizationProcedure from './components/RealizationProcedure';
import RecalculateDuties from './components/RecalculateDuties';
import { GridContainer } from 'components/shared/Grid/Grid.components';
import { StyledRealizationGrid } from './Realization.components';

// import hooks
import { useSelector } from 'hooks';

// import recoil
import { RecoilRoot } from 'recoil';

const Realization = () => {
  const { hasRealizationAccess } = useSelector(({ grants }) => grants);

  return (
    <>
      <PeriodSelector />
      <GridContainer>
        <StyledRealizationGrid>
          <RecalculateDuties />
        </StyledRealizationGrid>
        <StyledRealizationGrid>
          <RealizationProcedure />
        </StyledRealizationGrid>
        {hasRealizationAccess && (
          <StyledRealizationGrid>
            <BulkApproveDuties />
          </StyledRealizationGrid>
        )}
      </GridContainer>
      <DutyLineSummaryGrid />
    </>
  );
};

const RealizationContainer = (props) => {
  return (
    <RecoilRoot>
      <Realization {...props} />
    </RecoilRoot>
  );
};

export default RealizationContainer;
